import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, field, StringDecoder } from '@simonbackx/simple-encoding';
import { v4 as uuidv4 } from 'uuid';
import { Address } from './Address.js';
export class Premise extends AutoEncoder {
    id;
    name = '';
    description = '';
    premiseTypeIds = [];
    address = Address.createDefault();
    static createDefault(country) {
        return Premise.create({ address: Address.createDefault(country) });
    }
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], Premise.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder, version: 323 })
], Premise.prototype, "name", void 0);
__decorate([
    field({ decoder: StringDecoder, version: 323 })
], Premise.prototype, "description", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(StringDecoder) })
], Premise.prototype, "premiseTypeIds", void 0);
__decorate([
    field({ decoder: Address })
], Premise.prototype, "address", void 0);
//# sourceMappingURL=Premise.js.map